import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";

export const requestMails = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '销售',
            dataIndex: 'sales.name',
            key: 'salesName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.salesName || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '申请信息（名称：数量）',
            key: 'material',
            scopedSlots: {
                customRender: 'material'
            }
        },
        {
            title: '负责人',
            dataIndex: 'operator',
            key: 'operator',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.operator || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '处理时间',
            dataIndex: 'operatingTime',
            key: 'operatingTime',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '收件人信息',
            key: 'recipient',
            scopedSlots: {
                customRender: 'recipient'
            }
        },
        {
            title: '快递单号',
            dataIndex: 'trackingNumber',
            key: 'trackingNumber',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true
            },
            filteredValue: filteredInfo.trackingNumber || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '状态',
            key: 'status',
            scopedSlots: {
                customRender: 'status'
            }
        },
        {
            title: '送达时间',
            dataIndex: 'deliveryTime',
            key: 'deliveryTime',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        }, 
        {
            title: '创建人',
            dataIndex: 'createBy',
            key: 'createBy',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.createBy || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            key: 'createTime',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.remark || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
    ]
}
